import {
  DialogRoot,
  DialogBackdrop,
  DialogPositioner,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogCloseTrigger,
  Portal,
} from "@chakra-ui/react";

import { AuthenticationForm, AuthScreenName, AuthStartScreen } from "./AuthenticationForm";
import { useSmartNavigate } from "../../lib/useSmartNavigate";

interface AuthenticationDialogProps {
  isShown: boolean;
  onClose: () => void;
  onComplete?: () => void;
  onAuthenticated?: () => void | Promise<void>;
  source?: string;
  title: string;
  confirmLabel: string;
  screens?: AuthScreenName[];
  defaultEmail?: string;
  startScreen?: AuthStartScreen;
}

export const AuthenticationDialog = ({
  isShown,
  onClose,
  onComplete: onCompleteProp,
  onAuthenticated,
  source,
  title,
  confirmLabel,
  screens,
  defaultEmail,
  startScreen,
}: AuthenticationDialogProps) => {
  const navigate = useSmartNavigate();
  return (
    <DialogRoot
      open={isShown}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
      scrollBehavior="inside"
      lazyMount
      unmountOnExit
    >
      <Portal>
        <DialogBackdrop />
        <DialogPositioner>
          <DialogContent>
            <DialogHeader>
              <DialogTitle fontSize="lg" fontWeight="700">
                {title}
              </DialogTitle>
            </DialogHeader>
            <DialogBody>
              <AuthenticationForm
                confirmLabel={confirmLabel}
                source={source}
                screens={screens}
                defaultEmail={defaultEmail}
                startScreen={startScreen}
                onClose={onClose}
                onAuthenticated={onAuthenticated}
                onComplete={() => {
                  onClose();
                  if (onCompleteProp) {
                    onCompleteProp();
                  } else if (
                    // Keep the viewer on the event page when they signed
                    // in from it — they're mid-registration flow and the
                    // payment form or "you're registered" card renders on
                    // the same URL once logged in.
                    location.pathname
                      .toLowerCase()
                      .startsWith("/spark/atlanta/") ||
                    location.pathname
                      .toLowerCase()
                      .startsWith("/event/atlanta/")
                  ) {
                    navigate(location.pathname + "#join");
                  } else {
                    navigate("/events");
                  }
                }}
              />
            </DialogBody>
            <DialogCloseTrigger />
          </DialogContent>
        </DialogPositioner>
      </Portal>
    </DialogRoot>
  );
};
